<template>
  <div id="LowModule">
    <el-row>
      <el-col :span="6" v-for="(item,index) in DataArr" :key="index">
        <div class="mainBody" @click="jump(item.platform,item.createtime)">
          <i class="el-icon-error" style="color: red;position: absolute;top: -5px;right: -5px;cursor: pointer;" @click="remove(item.platform,item.createtime)" @click.stop></i>
          <div style="margin: 20px 20px 0px 20px;float: left;width: calc(100% - 40px);">
            <div class="platFormSty" v-show="item.platform != 'TBTM'">
              {{item.platform | platformChinese}}
            </div>
            <div class="platFormSty" v-show="item.platform == 'TBTM'">
              天猫淘宝
            </div>
            <div style="font-size: 22px;float: right;margin-top: -4px;">
              {{item.platformcount}}
            </div>
          </div>
          <div style="font-size: 14px;color: #a7a7a7;margin: 10px 20px 10px 20px;">
            数据同步时间：{{item.createtime | fullTime}}
          </div>
          <div style="font-size: 14px;text-align: left;margin-left: 20px;">
            <el-row>
              <el-col :span="4" style="margin-bottom: 10px;">
                授权
              </el-col>
              <el-col :span="3" style="margin-bottom: 10px;">
                <span v-show="item.whitecount">
                  {{parseInt(item.whitecount)}}
                </span>
                <span v-show="!item.whitecount">
                  0
                </span>
              </el-col>
              <el-col :span="5" style="margin-bottom: 10px;">
                <span v-if="item.whitepre">
                  {{item.whitepre}}%
                </span>
                <span v-else style="color: white;">
                  1
                </span>
              </el-col>

              <el-col :span="4" style="margin-bottom: 10px;">
                灰名单
              </el-col>
              <el-col :span="3" style="margin-bottom: 10px;">
                <span v-show="item.graycount">
                  {{parseInt(item.graycount)}}
                </span>
                <span v-show="!item.graycount">
                  0
                </span>
              </el-col>
              <el-col :span="5" style="margin-bottom: 10px;">
                <span v-if="item.graypre">
                  {{item.graypre}}%
                </span>
                <span v-else style="color: white;">
                  1
                </span>
              </el-col>

              <el-col :span="4">
                黑名单
              </el-col>
              <el-col :span="3">
                <span v-show="item.blackcount">
                  {{parseInt(item.blackcount)}}
                </span>
                <span v-show="!item.blackcount">
                  0
                </span>
              </el-col>
              <el-col :span="5">
                <span v-if="item.blackpre">
                  {{item.blackpre?item.blackpre:0}}%
                </span>
                <span v-else style="color: white;">
                  1
                </span>
              </el-col>
            </el-row>
          </div>
          <el-row>
            <el-col :span="24" id="new-button">
              <el-button size="small" plain style="width: 100%;float: left;margin-top: 13px;height: 39px;" @click.stop="productClick(item.platform,item.createtime,index)" :loading="lowPriceLoading[index]">下载数据</el-button>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      title="提示"
      :visible.sync="deleteShow"
      width="360px" style="margin-top: 10%;" id="dialog">
      <div style="display: flex;width: 100%;justify-content:center;">
          <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
         <div>
             <div style="font-size: 16px;">你确认要删除吗？</div>
          </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteClassification" size="small" :loading="ficationLoading">确 定</el-button>
        <el-button @click="deleteShow = false" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="productShow" width="360px" style="margin-top: 10%;" id="dialog">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 25px;"></i>
        <div>
          <div style="font-size: 16px;">选择不需要同步的产品</div>
        </div>
      </div>
      <div style="margin-top: 10px;">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="产品信息" label-width="100px">
            <el-select v-model="productid" multiple placeholder="请选择" size="small" @visible-change="getListBybmcid">
              <el-option
                v-for="item in options2"
                :key="item.id"
                :label="item.productClassifyName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downTable" size="small" type="primary" :loading="ficationLoading">确 定</el-button>
        <el-button @click="productShow = false" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    props: {
      "LowModuleData": Array
    },

    data(){
      return{
        productPlatform: '',
        productTime: '',
        productIndex: '',
        productShow: false,
        ficationLoading: false,
        lowPriceLoading: [],
        DataArr: [],
        loading: false,
        deleteShow: false,
        productid: [],
        options2: [],
        cascaderDisabled: false,
        productidChildren: {
          multiple: true,
          value: "id",
          label: "productClassifyName",
          children: "children"
        },
      }
    },
    watch:{
      LowModuleData:{
        handler(newVal){
          if(newVal){
            this.DataArr = newVal
            for (let i in this.DataArr) {
              this.lowPriceLoading.push(false)
            }
          }
        },
        immediate: true
      }
    },
    methods:{
      handleChange(value) {
        this.productid = value
      },
      getListBybmcid() {
        fetch({
          url: "hcm/hcmProduct/getListBybmcid",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(res => {
          let result = JSON.parse(res);
          if (result.status == "10000") {
            this.options2 = result.data;
          }
        });
      },
      productClick(platform,date,index) {
        this.productid = []
        this.productPlatform = platform
        this.productTime = date
        this.productIndex = index
        this.productShow = true
      },
      // 下载
      downTable(platform,date,index) {
        this.ficationLoading = true
        this.$set(this.lowPriceLoading,this.productIndex,true);
        let params = {
          platform: this.productPlatform,
          starttime: this.$options.filters['yearMonthDayTime'] (this.productTime),
          ischange: "null"
        };
        if (this.productid.length > 0) {
          params.products = this.productid.join(',')
        }
        fetch({
          url: "hcm/iprPluginList/exportLowPriceList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 30
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "日常违规检索详情.xlsx");
          document.body.appendChild(link);
          link.click();
          this.$set(this.lowPriceLoading,this.productIndex,false);
          this.ficationLoading = false
          this.productShow = false
        });
      },
      changeHash(idName) {
        document.querySelector(idName).scrollIntoView(true);
      },
      // 详情
      jump(platform,date) {
        this.$router.push({
          path: '/lowPriceDetails',
          query: {platform:platform,date:this.$options.filters['fullTime'](date)}
        })
      },
      // 打开删除弹框
      remove(e,f) {
        this.deleteShow = true
        this.platform = e
        this.dateTime = this.$options.filters['fullTime'](f)
      },
      // 确认删除
      deleteClassification() {
        this.ficationLoading = true
        let params={
          platformCode: this.platform,
          dateTime: this.dateTime
        }
        fetch({
          url: "hcm/iprPluginList/deleteCard",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.deleteShow = false
            this.ficationLoading = false
            this.$emit("delLowModule");
          } else {
            this.ficationLoading = false
            this.$message.error(res.message);
          }
        })
      },
    },
  }
</script>

<style lang="scss">
#LowModule {
  #new-button {
    .el-button--mini, .el-button--small {
      border-radius: 0 0 6px 6px !important;
    }
    .el-button {
      border-top: 1px solid #DCDFE6 !important;
      border-bottom: none !important;
      border-left: none !important;
      border-right: none !important;
    }
  }
  #dialog {

    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .el-dialog__title {
      font-size: 14px;
    }
  }
  .noData {
    width: calc(100% - 40px);
    text-align: center;
    background-color: white;
    padding: 20px;
    color: #999;
    height: 500px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #bda571;
    background: #bda571;
  }
  .el-radio__input.is-checked+.el-radio__label {
    color: #666;
  }
  .el-radio__inner:hover {
    border-color: #bda571;
  }
  .page {
    padding: 20px;
    margin-top: 10px;
    background-color: #fff!important;
    height: 100%;
  }
  .mainBody {
    cursor: pointer;
    margin: 8px;
    height: 179px;
    position: relative;
    background-color: white;
  }
  .mainBody:hover {
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }
  .platFormSty {
    font-size: 16px;
    float: left;
    font-weight: 600;
  }
  .platFormSty:hover {
    color: #409eff;
  }
  .aStyle {
    border: 1px solid #e5e9f2;
    width: 14.2%;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
  }
}
</style>
